import { z } from 'zod/v4';

export const fleetErrorSchema = z.object({
  detail: z.string().optional(),
  errorCode: z.number().optional(),
  message: z.string().optional(),
});
